import { render } from "./RegisterUser.vue?vue&type=template&id=6eda42d9&scoped=true"
import script from "./RegisterUser.js?vue&type=script&lang=js"
export * from "./RegisterUser.js?vue&type=script&lang=js"

import "./RegisterUser.scss?vue&type=style&index=0&id=6eda42d9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eda42d9"]])

export default __exports__